module.exports = {
  确认付款: 'ยืนยันการชำระเงิน',
  充值商品: 'สินค้าเติมเงิน',
  商品赠送: 'สินค้าฟรี',
  支付方式: 'วิธีชำระเงิน',
  实际支付: 'ชำระเงินตามจริง',
  立即充值: 'เติมเงินทันที',
  支付确认: 'ยืนยันการชำระเงิน',
  继续支付: 'ชำระเงินต่อ',
  请选择: 'กรุณาเลือก',
  用户协议: 'ข้อตกลงผู้ใช้งาน',
  隐私协议: 'ข้อตกลงความเป็นส่วนตัว',
  确定: 'ยืนยัน',
  游戏账号删除协议: 'ข้อตกลงการลบบัญชีเกม',
  账号删除进程: 'ขั้นตอนการลบบัญชี',
  '我们为您做出如下特别说明：在删除本游戏的游戏账号后，除法律法规或本协议另有规定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。前述个人信息包括但不限于头像、昵称、会员权益、等级/经验值等与游戏角色成长升级相关的所有数据、虚拟货币、虚拟道具等虚拟物品、聊天记录等内容。': 'เราขอชี้แจ้งรายละเอียดพิเศษดังต่อไปนี้: เมื่อลบบัญชีเกมของเกมนี้ นอกจากข้อบังคับหรือข้อตกลงทางกฎหมายและยังมีข้อกำหนดว่า ข้อมูลส่วนตัวของคุณที่อยู่ภายใต้บัญชีเกมนี้จะถูกลบหรือทำการไม่ระบุชื่อ และจะไม่เชื่อมโยงผลิตภัณฑ์และบริการที่เกี่ยวข้องที่เคยเชื่อมโยงกับบัญชีเกมอีกเมื่อลบบัญชีเกมนี้เสร็จสมบูรณ์แล้วจะไม่สามารถกู้คืนได้ และคุณจะไม่สามารถค้นหา ใช้งาน เข้าถึง และเรียกคืนได้อีก อีกทั้งยังไม่มีสิทธิ์ขอให้เราเรียกคืนข้อมูลส่วนตัวได้ กรุณาดำเนินการอย่างรอบคอบ ข้อมูลส่วนตัวดังกล่าวรวมถึงแต่ไม่จำกัดรูปโปรไฟล์ ชื่อเล่น สิทธิพิเศษสมาชิก เลเวล/EXP และข้อมูลทั้งหมดที่เกี่ยวข้องกับการอัปเกรดการเติบโตตัวละครในเกม เช่น สกุลเงินเสมือน ไอเทมเสมือน และอุปกรณ์เสมือนอื่น ๆ ประวัติแชท และเนื้อหาอื่น ๆ',
  '1、账号必须事先绑定邮箱。删除账号需要用邮箱进行验证，确保是本人操作。': '1.บัญชีผู้ใช้จะต้องผูกมัดกับอีเมล การลบบัญชีผู้ใช้จะต้องใช้อีเมลเพื่อทำการยืนยันว่าเจ้าของเป็นผู้ดำเนินการ',
  '2、游戏收益已结清或得到妥善处理：包括但不局限于游戏代币、道具、会员权益等收益。请您妥善处理，若未处理，视为您自愿放弃该等收益。': '2.ผลประโยชน์ของเกมได้ถูกลบหรือได้รับการดำเนินการอย่างเหมาะสม: รวมถึงแต่ไม่จำกัดเหรียญในเกม ไอเทม สิทธิพิเศษสมาชิก และผลประโยชน์อื่น ๆ กรุณาดำเนินการอย่างเหมาะสม และหากยังไม่ได้ดำเนินการจะถือว่าคุณละทิ้งผลประโยชน์ดังกล่าวด้วยความสมัครใจ',
  '3、账号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。': '3.บัญชีไม่มีข้อพิพาทใด ๆ: รวมถึงการฟ้องร้องหรือร้องเรียน ถูกร้องเรียน อนุญาโตตุลาการ และฟ้องร้องดำเนินคดีในศาล และข้อพิพาทอื่น ๆ',
  '亲爱的玩家，在您正式开始下一步有关本游戏的删除游戏账号流程前，请您务必先行仔细阅读、充分理解并同意《删除游戏账号协议》（以下统称“本协议”）。您按照游戏内提示的删除游戏账号之操作流程进行删除账号申请或开始删除账号流程的，或者您勾选本删除游戏账号协议并开始下一步操作的，均视为您已经同意和遵守本协议全部内容。': 'เรียน ผู้เล่น ก่อนที่คุณจะเริ่มขั้นตอนต่อไปที่เกี่ยวข้องกับกระบวนการลบบัญชีเกมของเกมนี้อย่างเป็นทางการ กรุณาอ่านรายละเอียด ทำความเข้าใจอย่างถี่ถ้วนและยอมรับ “ข้อตกลงการลบบัญชีเกม” (หรือเรียกอีกชื่อว่า “ข้อตกลงนี้”) หากคุณยื่นขอลบบัญชีหรือเริ่มกระบวนการลบบัญชีตามขั้นตอนการดำเนินการลบบัญชีเกมที่แจ้งเตือนในเกม หรือคุณทำเครื่องหมายข้อตกลงการลบบัญชีและเริ่มดำเนินการขั้นตอนต่อไป จะถือว่าคุณยอมรับและปฏิบัติตามเนื้อหาทั้งหมดของข้อตกลงนี้',
  有关删除游戏账号的其它详细规则及注意事项请点击查看: 'กฎและข้อควรระวังเกี่ยวกับรายละเอียดเพิ่มเติมอื่น ๆ ของการลบบัญชีเกม กรุณากดดูที่:',
  删除游戏账号协议: 'ข้อตกลงการลบบัญชีเกม',
  '将删除的游戏账号：': 'บัญชีเกมที่จะลบ',
  游戏账号: 'บัญชีเกม',
  游戏ID: 'ID เกม',
  失败原因: 'สาเหตุที่ล้มเหลว',
  '亲爱的用户，为确保您的账号安全，请提供您账号绑定的邮箱验证码以供账号删除校验，该验证码仅用于本次验证使用': 'เรียน ผู้ใช้งานเพื่อให้แน่ใจว่าบัญชีผู้ใช้ของคุณปลอดภัย กรุณาระบุรหัสยืนยันหมายเลขโทรศัพท์ที่ผูกมัดกับบัญชีผู้ใช้ของคุณสำหรับการยืนยันการลบบัญชี รหัสยืนยันนี้ใช้เพื่อการยืนยันครั้งนี้เท่านั้น',
  邮箱: 'อีเมล',
  验证码: 'รหัสยืนยัน',
  请输入验证码: 'ใส่รหัสยืนยัน',
  获取验证码: 'รับ',
  请描述你除账号的原因: 'โปรดอธิบายสาเหตุที่คุณลบบัญชี',
  '为防止误操作，请您再次确认是否删除游戏账号并确认删除后的影响，该影响包括但不限于（具体详见：': 'เพื่อป้องกันความผิดพลาดในการดำเนินการ โปรดยืนยันอีกครั้งว่าคุณต้องการลบบัญชีและยืนยันผลกระทบหลังจากการลบหรือไม่ ผลกระทบนี้รวมถึงแต่ไม่จำกัด (โปรดดูรายละเอียดเพิ่มเติม)',
  '1.该账号一旦删除成功，您将无法登录、使用该游戏账号，且无法回复。除法律法规和《删除游戏账号协议》另有约定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。': '1.เมื่อลบบัญชีนี้สำเร็จ คุณจะไม่สามารถล็อกอิน ใช้บัญชีเกมนี้ และไม่สามารถเรียกคืนได้อีก นอกจากข้อบังคับทางกฏหมายและ “ข้อตกลงการลบบัญชีเกม” และยังมีข้อกำหนดว่า ข้อมูลส่วนตัวของคุณที่อยู่ภายใต้บัญชีเกมนี้จะถูกลบหรือทำการไม่ระบุชื่อ และจะไม่เชื่อมโยงผลิตภัณฑ์และบริการที่เกี่ยวข้องที่เคยเชื่อมโยงกับบัญชีเกมได้อีก เมื่อลบบัญชีเกมนี้สำเร็จแล้วจะไม่สามารถกู้คืนได้ และคุณจะไม่สามารถค้นหา ใช้งาน เข้าถึง และเรียกคืนได้อีก อีกทั้งยังไม่มีสิทธิ์ขอให้เราเรียกคืนข้อมูลส่วนตัวได้ กรุณาดำเนินการอย่างรอบคอบ',
  '2.您确认知悉，删除游戏账号的，该账号在本游戏使用期间已产生及未来可能产生是所有游戏收益或权益将会被全部删除/清除。据此，也特别提示您，在您开始删除本游戏账号前请您妥善处理您的游戏收益或权益。否则，账号删除后，我们有权利对该账号下的全部收益或权益做删除/清除处理，因此产生的后果由您自行承担，前游戏收益或权益包括但不限于账号内剩余的所有游戏虚拟货币、虚拟道具及其它虚拟物品及增值服务。': '2.หากคุณยืนยันว่าจะลบบัญชีเกม ผลประโยชน์หรือสิทธิพิเศษของเกมทั้งหมดที่เกิดขึ้นแล้วหรืออาจจะเกิดขึ้นในอนาคตระหว่างการใช้เกมในบัญชีนี้จะถูกลบ/ล้างทั้งหมด นอกจากนี้สิ่งที่จะแจ้งให้คุณทราบเป็นพิเศษคือก่อนที่คุณจะเริ่มลบบัญชีเกมนี้ ขอให้คุณจัดการผลประโยชน์หรือสิทธิพิเศษของเกมอย่างถูกต้อง มิฉะนั้น หลังจากการลบบัญชี เรามีสิทธิ์ดำเนินการลบ/ล้างผลประโยชน์หรือสิทธิพิเศษทั้งหมดภายใต้บัญชีนี้ และคุณจะต้องยอมรับผลที่เกิดขึ้นกับผลประโยชน์หรือสิทธิพิเศษก่อนเริ่มเกมรวมถึงแต่ไม่จำกัดสกุลเงินเสมือน ไอเทมเสมือน และอุปกรณ์เสมือนอื่น ๆ และการบริการที่เพิ่มมูลค่าทั้งหมดที่เหลือภายในบัญชี',
  您的游戏角色将于: 'ตัวละครในเกมของคุณจะ',
  '完成删除。请注意，该账号删除有15日的冷静期(账号锁定期)。除法律法规规定和协议约定情形外 我们将在冷静期满后完成删除，删除或匿名化处理您的个人信息。': 'ถูกลบทั้งหมด โปรดทราบว่าการลบบัญชีนี้มีระยะเวลาพักเป็นเวลา 15 วัน (ช่วงล็อกบัญชี) นอกจากข้อบังคับทางกฎหมายและข้อกำหนดของข้อตกลง เราจะทำการลบหลังจากครบระยะการพักบัญชี โดยจะลบหรือทำการไม่ระบุข้อมูลส่วนตัวของคุณ',
  '在此期间，请您不要登录和使用该账号，以确保删除的顺利完成，否则视为您撤销删除申请。': 'ในระหว่างนี้โปรดอย่าล็อกอินและใช้บัญชีนี้ เพื่อให้แน่ใจว่าการลบเสร็จสมบูรณ์ มิฉะนั้นจะถือว่าเพิกถอนการยื่นขอลบบัญชี',
  确认删除游戏账号: 'ลบ',
  放弃删除: 'ละทิ้งการลบ',
  下一步: 'ขั้นตอนต่อไป',
  这是个多余的账号: 'นี่เป็นหมายเลขบัญชีที่ซ้ำ',
  弃游不想再玩: 'ไม่ต้องการเล่นอีก',
  需要换绑实名认证信息: 'ต้องการเปลี่ยนข้อมูลการยืนยันตัวตน',
  其他: 'อื่น ๆ',
  我已详细阅读并满足删除账号条件: 'ฉันได้อ่านและทำความเข้าใจเงื่อนไขการลบบัญชีอย่างละเอียดแล้ว',
  确认删除的游戏账号: 'ยืนยันลบบัญชีเกม',
  我已详细阅读并同意: 'ฉันได้ทำการอ่านและยอมรับแล้ว',
  验证本账号绑定的邮箱: 'ยืนยันอีเมลที่ผูกบัญชีนี้',
  选择删除的原因: 'เลือกสาเหตุที่ลบ',
  再次确认是否删除游戏账号并确认删除后的影响: 'ยืนยันอีกครั้งว่าคุณต้องการลบบัญชีและยืนยันผลกระทบหลังจากลบหรือไม่',
  删除游戏账号申请提交成功: 'ส่งยื่นขอลบบัญชีเกมสำเร็จ',
  完成: 'สำเร็จ',
  验证码发送成功: 'ส่งรหัสยืนยันแล้ว กรุณาตรวจรับ',
  '请先勾选【我已仔细阅读并满足账号删除条件】': 'โปรดทำเครื่องหมาย [ฉันได้อ่านและทำความเข้าใจเงื่อนไขการลบบัญชีอย่างละเอียดแล้ว] ก่อน',
  '请先勾选【我已阅读并同意': 'โปรดทำเครื่องหมาย [ฉันได้อ่านและยอมรับ “ข้อตกลงการลบบัญชีเกม” แล้ว] ก่อน',
  账号删除申请失败: 'ยื่นขอลบบัญชีล้มเหลว',
  验证成功: 'ยืนยันสำเร็จ',
  请选择删除原因: 'กรุณาเลือกสาเหตุที่ลบ',
  用户的游戏账号未绑定邮箱: 'บัญชีเกมของผู้ใช้ไม่ได้ผูกกับกล่องจดหมาย',
  游戏账号删除条件: 'เงื่อนไขการลบบัญชีเกม',
  需要解绑邮箱: 'ต้องยกเลิกการผูกอีเมล',
  '请先勾选【我已阅读并同意《游戏账号删除协议》】': 'โปรดทำเครื่องหมาย [ฉันได้อ่านและยอมรับ “ข้อตกลงการลบบัญชีเกม” แล้ว] ก่อน',
  支付失败: 'ชำระเงินล้มเหลว',
  购买中: 'กำลังซื้อ',
  支付成功: 'ชำระเงินสำเร็จ',
  购买失败: 'ซื้อล้มเหลว',
  购买成功: 'ซื้อสำเร็จ',
  全部: 'ทั้งหมด',
  '订单号：': 'รหัสใบสั่งซื้อ:',
  '时间：': 'เวลา:',
  '商品：': 'สินค้า:',
  '支付方式：': 'วิธีชำระเงิน:',
  '订单金额：': 'จำนวนเงินการสั่งซื้อ:',
  '支付金额：': 'จำนวนเงินที่ชำระ:',
  '钱包：': 'กระเป๋าเงิน:',
  '订单状态：': 'สถานะคำสั่งซื้อ:',
  '说明：': 'คำอธิบาย:',
  '如有疑问，请联系客服': 'หากมีข้อสงสัย กรุณาติดต่อแอดมิน',
  下拉更新: 'ดึงลงเพื่ออัปเดต',
  松开更新: 'ปล่อยเพื่ออัปเดต',
  更新中: 'กำลังอัปเดต',
  暂无数据: 'ไม่มีข้อมูล',
  '加载中……': 'กำลังโหลด...',
  你已完成储值: 'คุณเติมเงินสำเร็จ',
  返回游戏: 'กลับเกม',
  储值记录: 'ゲーム購入履歴',
  储值中心: 'ประวัติเติมเงินในเกม',
};



// WEBPACK FOOTER //
// ./src/common/lang/th.js